import type { Tracker } from './types/tracker';

/** 空实现 */
export class EmptyTracker implements Tracker {
  /**
   * @windowFunName 绑定到window的方法名
   */
  constructor() {}
  /**
   *
   * @param userId
   * @param params 给用户属性带参数
   * @returns
   */
  login = (userId: string, params?: any, flush?: boolean) => {
    return this as unknown as Tracker;
  };
  logout = () => {
    return this as unknown as Tracker;
  };
  trackEvent = (eventName: string, data: any, _flush?: boolean) => {
    return this as unknown as Tracker;
  };
  addUserAttribute = (data: any, flush?: boolean) => {
    return this as unknown as Tracker;
  };
  evtParams: any = {};
  setCommonParams = (appendExtParams: any, flush?: boolean) => {
    this.evtParams = appendExtParams;
    this.trackEvent(
      'config',
      {
        ...this.evtParams,
      },
      flush
    );
    return this as unknown as Tracker;
  };
  addCommonParams = (extParams: any, flush?: boolean) => {
    Object.assign(this.evtParams, extParams);
    this.trackEvent(
      'config',
      {
        evtParams: { ...this.evtParams },
      },
      flush
    );

    return this as unknown as Tracker;
  };
}
